/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonERP } from "@finanedi.es/storybook"
import { t } from "i18next"
import { Dropdown } from "primereact/dropdown"
import { InputTextarea } from "primereact/inputtextarea"
import React from "react"
import {
  DocumentValidationProps,
  FLOW_STATUS_OPTIONS_DROPDOWN,
} from "../../../constant"

const DocumentValidation: React.FC<DocumentValidationProps> = ({
  documentsToValidate,
  handleSelect,
  dataToValidate,
  isValidating,
  handleChange,
  handleHide,
}: $TSMigrationFixMe): React.JSX.Element => {
  return (
    <div className='tw-bg-white tw-p-4 tw-rounded tw-flex tw-flex-col tw-shadow tw-mb-6 tw-text-base'>
      <h6 className='tw-text-left tw-text-text tw-font-medium tw-text-sm'>
        {t("documentos.validar.idView.validationTitle")}
      </h6>

      <div className='tw-mt-6 tw-text-left tw-text-sm'>
        <div className=''>
          <label htmlFor='importeDesde'>
            {t("documentos.validar.idView.stateLabel")}
          </label>
          <Dropdown
            placeholder={
              t("documentos.validar.idView.placeholderState") ?? undefined
            }
            options={FLOW_STATUS_OPTIONS_DROPDOWN(t)}
            className='rounded-none w-100'
            name='tipoDocumento'
            id='tipoDocumento'
            onChange={handleSelect}
            value={dataToValidate.estadoRevision}
          />
        </div>
        <div className='tw-w-full tw-flex tw-flex-col tw-mt-6'>
          <label htmlFor='t'>
            {t("documentos.validar.idView.comentLabel")}
          </label>
          <InputTextarea
            rows={8}
            cols={30}
            onChange={handleChange}
            maxLength={120}
          />
        </div>
      </div>

      <div
        className={`tw-flex tw-flex-row ${
          dataToValidate?.lastSignature
            ? "tw-w-full tw-justify-between"
            : "tw-justify-end"
        } tw-mt-6 tw-gap-3`}
      >
        <ButtonERP
          customize={{
            size: "md",
            type: "transparent",
          }}
          label={`${
            dataToValidate?.lastSignature
              ? t("validaciones.documentos.detail.previous")
              : t("documentos.validar.idView.cancelButton")
          }`}
          type='button'
          onClick={handleHide}
        />
        <ButtonERP
          customize={{
            size: "md",
            type: "secondary",
          }}
          disabled={Boolean(!documentsToValidate) || Boolean(isValidating)}
          label={`${t("documentos.validar.idView.confirmButton")}`}
          type='submit'
        />
      </div>
    </div>
  )
}

export default DocumentValidation
